import React, { useState } from "react";
import { httpReauest } from "../../../utils/httpRequest";
import { toast } from "react-toastify";
import WheelOfFortuneLayout from "../../layout/WheelOfFourtune";

const WheelofFourtuneModal = ({ getData , data }) => {
  return (
    <div className="z-30 pb-8 sm:pb-8 overflow-hidden">
      <h4 className="text-[20px] lg:text-[28px] text-white font-bold text-center uppercase">
        Wheel of fortune
      </h4>
      <div className="relative w-full">
        <WheelOfFortuneLayout getData={getData} data={data} />
      </div>
    </div>
  );
};

export default WheelofFourtuneModal;
